import axios from 'axios';

const list = (data) => axios.get('/safe/alarm/planList', data);
const save = (data) => axios.post('/safe/alarm/savePlan', data);
const del = (data) => axios.post('/safe/alarm/delPlan', data);


export default {
  list,
  save,
  del,

}


